import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const wechatinfo = async (params: object) => {
  return await GET({ url: Api.wechatinfo, params, showError: false })
}
